import { EntitySwitch, isKind } from "@backstage/plugin-catalog";

import apiPage from "./pages/api";
import componentPage from "./pages/component";
import defaultEntityPage from "./pages/default";
import domainPage from "./pages/domain";
import groupPage from "./pages/group";
import resourcePage from "./pages/resource";
import systemPage from "./pages/system";
import userPage from "./pages/user";

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind("api")} children={apiPage} />
    <EntitySwitch.Case if={isKind("component")} children={componentPage} />
    <EntitySwitch.Case if={isKind("domain")} children={domainPage} />
    <EntitySwitch.Case if={isKind("group")} children={groupPage} />
    <EntitySwitch.Case if={isKind("resource")} children={resourcePage} />
    <EntitySwitch.Case if={isKind("system")} children={systemPage} />
    <EntitySwitch.Case if={isKind("user")} children={userPage} />

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
